import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import './style.scss'

type GroupItemSkeletonLoadingProps = {
  imgWidth?: number
  imgHeight?: number
}

const GroupItemSkeletonLoading = ({
  imgWidth = 70,
  imgHeight = 70,
}: GroupItemSkeletonLoadingProps) => {
  return (
    <div className="GroupItemSkeleton">
      <Skeleton width={imgWidth} height={imgHeight} borderRadius={16} />

      <div className="GroupItemSkeleton__content">
        <Skeleton width={120} />
        <Skeleton width="100%" />

        <Skeleton
          containerClassName="GroupItemSkeleton__description"
          count={2.2}
        />

        <div className="GroupItemSkeleton__tags">
          <Skeleton width={40} />
          <Skeleton width={40} />
          <Skeleton width={40} />
        </div>

        <Skeleton
          width={24}
          height={24}
          circle
          containerClassName="GroupItemSkeleton__menu"
        />
      </div>
    </div>
  )
}

export default GroupItemSkeletonLoading
